<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog title="修改分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="所属分类" :label-width="formLabelWidth">

<!--        <el-select v-model="form.parentId">-->
<!--          <el-option label="顶级分类" :value="0"></el-option>-->
<!--          <el-option :value="cat.categoryId" :label="cat.name" :key="cat.categoryId" v-for="cat in editform.catList"></el-option>-->
<!--        </el-select>-->

        <wlTreeSelect  disabled="disabled" leaf width="240"  :props="props" :leaf="false" :checkbox="false" :data="treeData" @change="hindleChanged"  v-model="selected">
        </wlTreeSelect>
      </el-form-item>
      <el-form-item label="分类名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类图片" prop="imageId" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.imageId!=''&&form.imageId!='0'" class="img">
            <img :src="filePath" width="100" height="100" />
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg()">删除图片<i class="el-icon-close"></i></a>

          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="分类排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>
  import PorductApi from '@/api/product.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        value: [], // 选中值
        selectValue:[],
        treeData: this.editform.catList,
        selected: [  ],// 树下拉框选中数据
        form: {
          categoryId: 0,
          parentId: 0,
          parentName: '顶级分类',
          name: '',
          imageId: '',
          sort: ''
        },
        filePath: '',
        formRules: {
          name: [{
            required: true,
            message: '请输入分类名称',
            trigger: 'blur'
          }],
          // imageId: [{
          //   required: true,
          //   message: '请上传分类图片',
          //   trigger: 'blur'
          // }],
          sort: [{
            required: true,
            message: '分类排序不能为空'
          }, {
            type: 'number',
            message: '分类排序必须为数字'
          }]
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        loading: false,
        /*是否上传图片*/
        isupload: false,
      };
    },
    props: ['open_edit', 'editform'],
    created() {
      this.dialogVisible = this.open_edit;
      console.log(this.editform.catList,"=======");

      this.form.categoryId = this.editform.model.categoryId;
      this.form.parentId = this.editform.model.parentId;
      this.form.parentName = this.editform.model.parentName;

      this.form.imageId = this.editform.model.imageId;
      this.form.name = this.editform.model.name;
      this.form.sort = this.editform.model.sort;
      this.filePath = this.editform.model.imagePath;
      // this.selectValue=[{name:this.form.parentName ,categoryId:this.form.parentId}];
      this.selected=[{name:this.form.parentName ,categoryId:this.form.parentId}];


    },
    methods: {
      hindleChanged(val){
       // this.selectValue=[{name:val[0].parentName,categoryId:val[0].categoryId}];
        console.log(this.selected)
      },
      /*修改用户*/
      addUser() {
            if(this.selected.length!=0){
                this.form.parentId = this.selected[0].categoryId;

            }else{
                this.form.parentId = this.editform.categoryType;
            }
          this.form.categoryType=this.editform.categoryType;
          let self = this;
        let params = self.form;
        console.log("********",params)
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            PorductApi.catEdit(params, true).then(data => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }).catch(error => {
              self.loading = false;
            });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },
      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.filePath = e[0].filePath;
          this.form.imageId = e[0].fileId;
        }
        this.isupload = false;
      },
       /*删除商品图片*/
        deleteImg() {
            this.form.imageId = '0'; // 清空 imageId
            this.filePath = ''; // 清空 filePath
            this.editform.model.imageId = ''; // 清空 editform 中的 imageId
            this.editform.model.imagePath = ''; // 清空 editform 中的 imagePath
            this.$forceUpdate(); // 强制更新视图，确保图片被清除

        }
    }
  };

</script>

<style>
  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/product/category/Edit.vue